import api from './api';

const CallAPI = {
    getCalls: async () => {
        const response = await api.get('/calls/today');
        return response.data;
    },
    getHourlyCalls: async (type='total') => {
        const response = await api.get(`/calls/today/hourly/${type}`);
        return response.data;
    },
    getCallCosts: async () => {
        const response = await api.get('/calls/today/cost');
        return response.data;
    }
}

export default CallAPI;